import React, {useState} from 'react'
import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import DashboardHeader from './DashboardHeader';
import DashboardBody from './DashboardBody';
import { useHealthMetrics } from './hooks/useHealthMetrics';

const HealthMetricsDashboard = ({otherUserInfo = null}) => {
  // console.log("otherUserInfo: ", otherUserInfo)
  const { userInfo } = useSelector(state => state.user);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [customDateRange, setCustomDateRange] = useState({
    from: '',
    to: ''
  });

  const {
    loadingMetrics,
    healthMetrics,
    timeRange,
    timeRangeType,
    fetchHealthMetrics,
    handleTimeRangeChange,
    handleCustomDateApply,
    calculateDateRange
  // } = useHealthMetrics(userInfo);
  } = useHealthMetrics(otherUserInfo ? otherUserInfo : userInfo);

  return (
    <div className="health-metrics-dashboard mt-4">
      <Card className="border-primary shadow-sm">
        <DashboardHeader
          healthMetrics={healthMetrics}
          timeRangeType={timeRangeType}
          loadingMetrics={loadingMetrics}
          isCollapsed={isCollapsed}
          calculateDateRange={calculateDateRange}
          fetchHealthMetrics={() => fetchHealthMetrics(timeRange)}
          setIsCollapsed={setIsCollapsed}
        />

        {!isCollapsed && (
          <DashboardBody
            healthMetrics={healthMetrics}
            timeRangeType={timeRangeType}
            timeRange={timeRange}
            userInfo={userInfo}
            handleTimeRangeChange={handleTimeRangeChange}
            customDateRange={customDateRange}
            setCustomDateRange={setCustomDateRange}
            handleCustomDateApply={handleCustomDateApply}
          />
        )}
      </Card>
    </div>
  );
};

export default HealthMetricsDashboard;